import {
  arrayOf,
  bool,
  element,
  func,
  object,
  oneOfType,
  shape,
  string,
} from 'prop-types'
import React from 'react'
import { CalendarContainer } from 'react-datepicker'

import './CustomCalendarContainer.less'

const CustomCalendarContainer = ({
  className = '',
  children,
  fullScreen,
  showPopperArrow,
  arrowProps,
  message,
}) => {
  return (
    <div className={`ra-calendar-container`}>
      <CalendarContainer
        showPopperArrow={!fullScreen && showPopperArrow}
        arrowProps={arrowProps}
        className={`ra-calendar-container__container ${className}`}
      >
        <div className="calendar-container__content">{children}</div>
        {fullScreen && message && (
          <p className="ra-calendar-container__message">{message}</p>
        )}
      </CalendarContainer>
    </div>
  )
}

CustomCalendarContainer.propTypes = {
  className: string,
  children: arrayOf(oneOfType([element, arrayOf(element)])),
  showPopperArrow: bool,
  message: string,
  onClose: func,
  fullScreen: bool,
  arrowProps: shape({
    ref: func,
    style: object,
  }),
}

export { CustomCalendarContainer }
